import React, { useCallback, useMemo, useState } from 'react';

const DayCell = React.memo(({ day, selected, onClick, value, handleMouseEnter, inRange }) => {
  return (
    <div
      className={`day-cell${selected ? ' selected' : ''}${inRange ? ' day-cell_in-range' : ''}`}
      onClick={(e) => onClick(day, e)}
      onMouseEnter={() => {handleMouseEnter(day)}}
    >
      {day}
    </div>
  );
});

const DayRangePicker = ({ value, onChange, onClose }) => {
  const [startDay, setStartDay] = useState(value[0]);
  const [endDay, setEndDay] = useState(value[1]);
  const [dayToHighlightRange, setDayToHighlightRange] = useState(value[0])
  const days = useMemo(() => Array.from({ length: 28 }, (_, i) => i + 1), []);

  const handleDayClick = useCallback(
    (day) => {
      console.log(day)
      if (!startDay) {
        setStartDay(day);
        onChange([day, endDay]);
      } else if (!endDay) {
        if (day > startDay) {
          setEndDay(day);
          onChange([startDay, day]);
          onClose();
        } else {
          setStartDay(day);
          onChange([day, endDay ? endDay : day]);
        }
      } else {
        setStartDay(day);
        setEndDay(null);
        onChange([day, day]);
      }
    },
    [startDay, endDay, onChange, onClose]
  );

  function handleMouseEnter(day) {
    if (startDay < day) {
      setDayToHighlightRange(day);
    } else setDayToHighlightRange(value[0])
  }

  return (
    <div className="table">
      {days.map((day) => (
        <DayCell
          key={day}
          day={day}
          selected={day >= value[0] && day <= value[1]}
          inRange={day >= value[0] && day < dayToHighlightRange}
          onClick={handleDayClick}
          handleMouseEnter={handleMouseEnter}
          value={value}
        />
      ))}
    </div>
  );
};

export default DayRangePicker;
